<div class="page">
    <div class="page-header">
        <div class="header-left">
            <mat-icon class="back-icon" routerLink="/series">arrow_back</mat-icon>
            <h3>{{ 'serie.add.title' | translate }}</h3>
        </div>
    </div>

    <div class="form-card">
        <h4 class="section-title">{{ 'serie.add.basicData' | translate }}</h4>
        <form novalidate [formGroup]="serieForm!">
            <div class="form-row">
                <label for="serieName">{{ 'serie.add.name' | translate }} <span class="required">*</span></label>
                <div class="form-input">
                    <input formControlName="serieName" id="serieName" type="text" required [(ngModel)]="serie.serieName" />
                </div>
            </div>
        </form>
    </div>

    <div class="form-card">
        <h4 class="section-title">{{ 'serie.add.elements' | translate }}</h4>
        <div class="drag-and-drop-container">
            <div class="search-main-container">
                <div class="search-bar">
                    <mat-icon fontIcon="search" />
                    <input placeholder="{{ 'serie.add.searchPlaceholder' | translate }}" type="search" [(ngModel)]="searchText" />
                </div>
                <div class="category-info">
                    @if (serie.serieName) {
                        <span>{{ serie.serieName }} — {{ 'serie.add.elementCount' | translate }}: {{ selectedBookList.length }}</span>
                    }
                    @if (!serie.serieName) {
                        <span>{{ 'serie.add.newSerie' | translate }} — {{ 'serie.add.elementCount' | translate }}: {{ selectedBookList.length }}</span>
                    }
                </div>
            </div>
            <div class="drag-and-drop">
                <div class="products-panel">
                    <h5 class="panel-title">{{ 'serie.add.availableProducts' | translate }}</h5>
                    <div class="products-list">
                        @for (product of products | filter: searchText; track product) {
                            <div class="product-item">
                                <span>{{ product.author + ': ' + product.title }}</span>
                                <mat-icon class="action-icon action-icon--add" (click)="addProduct(product)">add_circle_outline</mat-icon>
                            </div>
                        }
                    </div>
                </div>
                <div class="products-panel">
                    <h5 class="panel-title">{{ 'serie.add.serieProducts' | translate }}</h5>
                    <div cdkDropList class="products-list" (cdkDropListDropped)="drop($event)">
                        @for (product of selectedBookList; track product; let i = $index) {
                            <div cdkDrag class="product-item">
                                <mat-icon class="drag-handle" fontIcon="drag_indicator" />
                                <b class="order-number">{{ i + 1 }}</b>
                                <span>{{ product.book?.author + ': ' + product.book?.title }}</span>
                                <mat-icon class="action-icon action-icon--remove" (click)="deleteFromSerie(product)">remove_circle_outline</mat-icon>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>

        <div class="submit-row">
            <button type="button" class="btn btn-submit" [disabled]="!serieForm?.valid" (click)="addSerie()">
                {{ 'serie.add.submitButton' | translate }}
            </button>
        </div>
    </div>
</div>
